import { PropertyOwnerPermissionType, OwnerFormula } from 'models/Owner';
import * as Yup from 'yup';

export const formSchema = Yup.object({
  uid: Yup.string().required(),
  formula: Yup.mixed<OwnerFormula>()
    .oneOf(Object.values(OwnerFormula))
    .notRequired(),
  [PropertyOwnerPermissionType.READING_CALENDAR]: Yup.boolean(),
  [PropertyOwnerPermissionType.READING_BOOKING_DETAILS]: Yup.boolean(),
  [PropertyOwnerPermissionType.READING_BOOKING_VALUE]: Yup.boolean(),
  [PropertyOwnerPermissionType.CREATING_BLOCKS]: Yup.boolean(),
  [PropertyOwnerPermissionType.VIEW_ANALYTICS]: Yup.boolean(),
});

export type OwnerPermissionsFormSchemaType = Yup.InferType<typeof formSchema>;
